module.exports = __webpack_public_path__ + "img/user-config.3d884273.svg";